import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { IndividualRecipientReportDataModel, RecipientReportDataModel } from '../recipient.report.data.model';
import { ButtonTypesEnum } from '../../../../../Forms/enums/button-types.enum';
import { DistributionReportStat } from '../../../../model/statisticsReport/distribution-report-stat-api.model';
import { ActionKeys } from '../../../../../Forms/enums/keys.enum';
import { StatTypeChangeInterface } from '../../../../model/statisticsReport/stat-type-change.interface.model';
import { AgprMath } from '../../../../../../Common/Misc/helpers/math/math-helper';
import { StatisticsReportService } from '../../../../../../Common/TargetingShared/services/statistics.report.service';
import { LocalizationService } from '@Core/Localization/services/localization.service';
import { DistributionReportStatisticTypesEnum } from '@Common/TargetingShared/enum/distribution-report-statistic-types.enum';

@Component({
    selector: 'agpr-individual-recipient-report',
    templateUrl: './individual.recipient.report.component.html',
    styleUrls: ['./individual.recipient.report.component.scss'],
    standalone: false
})
export class IndividualRecipientReportComponent implements OnInit {
    @Input() data: IndividualRecipientReportDataModel;
    @Input() clickTracking: boolean = true;
    @Input() openTracking: boolean = true;
    @Input() selectedType: DistributionReportStat;
    @Input() selectedIndividualRecipient: IndividualRecipientReportDataModel;

    @Output() statTypeSelected: EventEmitter<StatTypeChangeInterface> = new EventEmitter<StatTypeChangeInterface>();

    expanded: boolean = false;
    selectedItem: string = '';
    uniqueOpenRatioPercentageChangeFromBenchmark: number= 0;
    uniqueOpenRatioTooltip: string= '';
    uniqueClickRatioPercentageChangeFromBenchmark: number= 0;
    uniqueClickRatioTooltip: string= '';
    deliveredRatioPercentageChangeFromBenchmark: number= 0;
    deliveredRatioTooltip: string= '';



    readonly buttonTypes = ButtonTypesEnum;
    readonly statTypes = DistributionReportStat;
    recipientReportData: RecipientReportDataModel;

    constructor(
        public statisticsReportService: StatisticsReportService,
        public localizationService: LocalizationService,
    ){}

    ngOnInit(): void {
        this.statisticsReportService.recipientReportData$.subscribe(recipientReportData => {
            this.recipientReportData = recipientReportData;
            this.indivBenchMarkDifference();
            this.setTooltips();
        });
    }

    indivBenchMarkDifference() {
        if (this.recipientReportData?.benchmarkStats) {
            this.uniqueOpenRatioPercentageChangeFromBenchmark =
            AgprMath.round((
                (isNaN(this.data.uniqueOpenRatio) ? 0 : this.data.uniqueOpenRatio) * 100) - this.recipientReportData.benchmarkStats.uniqueOpenRate , 1);
            this.uniqueClickRatioPercentageChangeFromBenchmark =
            AgprMath.round((
                (isNaN(this.data.uniqueClickRatio) ? 0 : this.data.uniqueClickRatio) * 100) - this.recipientReportData.benchmarkStats.uniqueClickRate , 1);
            this.deliveredRatioPercentageChangeFromBenchmark =
            AgprMath.round((
                (isNaN(this.data.deliveredRatio) ? 0 : this.data.deliveredRatio) * 100) - this.recipientReportData.benchmarkStats.deliveryRate , 1);
        }
    }

    private getLocalizedTooltipForBenchmarkComparison(differenceOverBenchmark?: number, statisticType?: DistributionReportStatisticTypesEnum): string {
        let description = this.localizationService.transform('Discover.targeting.distribution.recipient.report.lowerThan');
        if (differenceOverBenchmark > 0) {
            description = this.localizationService.transform('Discover.targeting.distribution.recipient.report.higherThan');
        }

        return this.localizationService.transform(
            this.recipientReportData?.isBriefingReport ?
                'Discover.targeting.briefing.recipient.report.benchmarkStatisticComparison.tooltip' :
                'Discover.targeting.distribution.recipient.report.benchmarkStatisticComparison.tooltip',
            {
                'statisticType': this.localizationService.transform(`Discover.targeting.distribution.statistic.lowercase.${statisticType}`),
                'value': `${Math.abs(differenceOverBenchmark)}%`,
                'description': description,
                'benchmarkType':  this.localizationService.transform('Discover.targeting.distribution.recipient.report.average')
            }
        );
    }

    private setTooltips() {
        this.deliveredRatioTooltip = this.getLocalizedTooltipForBenchmarkComparison(
            this.deliveredRatioPercentageChangeFromBenchmark,
            DistributionReportStatisticTypesEnum.DELIVERY_RATE
        );

        this.uniqueOpenRatioTooltip = this.getLocalizedTooltipForBenchmarkComparison(
            this.uniqueOpenRatioPercentageChangeFromBenchmark,
            DistributionReportStatisticTypesEnum.UNIQUE_OPEN_RATE
        );

        this.uniqueClickRatioTooltip = this.getLocalizedTooltipForBenchmarkComparison(
            this.uniqueClickRatioPercentageChangeFromBenchmark,
            DistributionReportStatisticTypesEnum.UNIQUE_CLICK_RATE
        );
    }


    selectStatType(statType: DistributionReportStat) {
        this.selectedItem= statType;
        this.statTypeSelected.next({
            statType,
            data: this.data
        });
    }

    statCardKeydown(event: KeyboardEvent, statType: DistributionReportStat) {
        if (event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE) {
            this.selectStatType(statType);
        }
    }
}
